import gql from 'graphql-tag';

const UPDATE_DATA_FREQUENCY = gql`
  mutation Mutation($deviceSerialNo: String!, $dataFrequency: Int!) {
    updateFrequency(deviceSerialNo: $deviceSerialNo, dataFrequency: $dataFrequency) {
      code
    }
  }
`;

export default UPDATE_DATA_FREQUENCY;
